import React from 'react';
import {
  core_apimessages_Money as Money,
  core_apimessages_CheckoutPaymentMethod_Type as CheckoutPaymentMethodType,
} from '@reverbdotcom/commons/src/gql/graphql';
import { useApplePayAvailabilityByConfig } from './useApplePayAvailability';
import { isCartEligible } from './checkout/ExpressPayPalButton';
import { CartHoistedExpressPayOptions } from './cart/CartHoistedExpressPayOptions';
import { findMerchantId, merchantName } from './checkoutApplePay';
import { ApplePayConfig } from './useCartApplePay';
import { usePayPalPayLaterButtonAvailability } from './useExpressPayPal';

interface Props {
  paymentMethodType: string;
  checkoutBundlingId: string;
  amountTotal: Money;
  adyenCheckoutPaymentMethodsConfig: string;
  currency: string;
  shopCountryCode: string;
  paypalCheckoutEligibilityAttributes: {
    currencyCount: number,
    bundleCount: number,
    shopCount: number,
    isLocalPickupOnly: boolean,
    includesStandalonePaypal: boolean,
  },
}

export default function CartHoistedExpressPayWrapper({
  paymentMethodType,
  checkoutBundlingId,
  amountTotal,
  adyenCheckoutPaymentMethodsConfig,
  currency,
  paypalCheckoutEligibilityAttributes,
  shopCountryCode,
}: Props) {
  const [isApplePayAvailable] = useApplePayAvailabilityByConfig(adyenCheckoutPaymentMethodsConfig);
  const showApplePayButton = isApplePayAvailable && paymentMethodType == CheckoutPaymentMethodType.DIRECT_CHECKOUT;

  const showPayPalButton = isCartEligible(paypalCheckoutEligibilityAttributes);
  const isPaypalPayLaterAvailable = usePayPalPayLaterButtonAvailability({
    currency: amountTotal.currency,
    amountCents: amountTotal.amountCents,
    shopCountryCode,
  });

  const applePayConfig: ApplePayConfig = {
    merchantId: findMerchantId(JSON.parse(adyenCheckoutPaymentMethodsConfig)),
    merchantName: merchantName(),
  };

  return (
    <CartHoistedExpressPayOptions
      checkoutBundlingId={checkoutBundlingId}
      amountTotal={amountTotal}
      currency={currency}
      showApplePayButton={showApplePayButton}
      applePayConfig={applePayConfig}
      showPayPalButton={showPayPalButton}
      showPaypalPayLaterButton={isPaypalPayLaterAvailable}
    />
  );
}
